var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7151 4.28125H6.46509",
    stroke: "#555555",
    strokeWidth: 1.27253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21484 10.1152H2.96484",
    stroke: "#555555",
    strokeWidth: 1.27253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9646 11.8641C10.9311 11.8641 11.7146 11.0806 11.7146 10.1141C11.7146 9.14764 10.9311 8.36414 9.9646 8.36414C8.9981 8.36414 8.2146 9.14764 8.2146 10.1141C8.2146 11.0806 8.9981 11.8641 9.9646 11.8641Z",
    stroke: "#555555",
    strokeWidth: 1.27253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1311 6.0318C5.0976 6.0318 5.8811 5.2483 5.8811 4.2818C5.8811 3.3153 5.0976 2.5318 4.1311 2.5318C3.16461 2.5318 2.3811 3.3153 2.3811 4.2818C2.3811 5.2483 3.16461 6.0318 4.1311 6.0318Z",
    stroke: "#555555",
    strokeWidth: 1.27253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.add029d166c02dc022953c74a9898e1f.svg";
export { ForwardRef as ReactComponent };